import LinkList from "../components/LinkList";

const ListLinkPage = () => {
  return (
    <LinkList />
  );
};

export default ListLinkPage;
